import { useGetModuleDefinitionsQuery } from '@platform/state/api';
import type { ICatalog, IModuleDefinition } from '@platform/core/types';
import { installedHere } from '../../shell/installedHere';
import { useWorkspaceCatalog } from '../../shell/useWorkspaceCatalog';
import { moduleRank } from './moduleRank';

/**
 * Каталог простору й визначення його модулів (для «Налаштувань»: поля, форми, конструктор): глобально — усі модулі каталогу (злиті з
 * глобальним шаром, ADR-027), у просторі — встановлені, зокрема вимкнені в просторі чи глобально (реєстри Ради поза парламентом — лише з
 * записами, як у прототипі). Визначення вантажаться одним запитом стану на всі модулі (GET /meta/modules/{key}) і кешуються на годину; порядок — як у
 * верхньому меню (moduleRank).
 */
export function useWorkspaceDefinitions(ws: string, global: boolean): { catalog: ICatalog | undefined; definitions: IModuleDefinition[] | undefined } {
  const { catalog } = useWorkspaceCatalog(ws);
  const rank = moduleRank();
  const keys = (catalog?.modules ?? []).filter((m) => global || installedHere(m)).map((m) => m.key).sort((a, b) => rank(a) - rank(b) || a.localeCompare(b)).join(',');
  const { data: definitions } = useGetModuleDefinitionsQuery({ keys, workspaceId: global ? undefined : ws }, { skip: !keys });
  return { catalog, definitions };
}
